module.exports = __webpack_public_path__ + "static/media/lovehero.5fca375a.jpg";